// @flow
import React from 'react';
import { Flex, Box } from '@rebass/grid';
import styled from 'styled-components';
import { Button, useModal, Modal, ModalFooter } from 'freemium-ui';
import Icons from 'components/Icons';
import { useComponentGroups, useComponentStatuses } from 'shared/hooks';
import FormikReset from './FormikReset';
import PreviewModal from '../../IncidentPreview';
import i18n from '../../../i18n';

type Props = {
  showReset: boolean,
  values: any,
  type: string,
  currentAccountMeta: any,
  currentIncident: any,
  submitForm: any,
  formProp: any,
  incidentType: any,
  activeAccount: any,
  close: any
};

const FormFooter = (props: Props) => {
  const {
    values,
    submitForm,
    showReset = false,
    activeAccount,
    currentAccountMeta,
    incidentType,
    type,
    currentIncident,
    close,
    formProp
  } = props;
  const { setVisible, bindings } = useModal();
  const submitText = currentIncident
    ? i18n.t('components.createIncident.update')
    : values.privacy === 'Private'
    ? i18n.t('components.createIncident.save')
    : type === 'public'
    ? i18n.t('components.createIncident.publish')
    : i18n.t('components.createIncident.schedule');
  const submittingText = {
    Update: i18n.t('components.createIncident.updating'),
    Save: i18n.t('components.createIncident.saving'),
    Publish: i18n.t('components.createIncident.publishing'),
    Schedule: i18n.t('components.createIncident.scheduling')
  };
  const { data: components } = useComponentStatuses();
  const { data: componentGroups = [] } = useComponentGroups();

  return (
    <FlexFooter
      justifyContent={
        values.privacy !== 'Private' ? 'space-between' : 'flex-end'
      }
    >
      {values.privacy !== 'Private' && (
        <Box>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => setVisible(true)}
          >
            <Icons glyph="visible" viewBox="0 -5 16 16" size="16" />
            {` `}
            {i18n.t('components.createIncident.preview')}
          </Button>
          <Modal styles={{ padding: '0' }} {...bindings} size="large">
            <PreviewModalWrapper
              close={() => setVisible(false)}
              values={values}
              submitForm={submitForm}
              incidentType={incidentType}
              activeAccount={activeAccount}
              currentAccountMeta={currentAccountMeta}
              components={components}
              componentGroups={componentGroups}
            />
          </Modal>
        </Box>
      )}
      <Flex>
        <Button
          type="secondary"
          htmlType="button"
          style={{ width: 'auto' }}
          onClick={close}
        >
          {i18n.t('components.createIncident.cancel')}
        </Button>
        {showReset && <FormikReset formProp={formProp} />}
        <Box id="submit-btn" ml={2}>
          <Button
            inline
            type="primary"
            htmlType="button"
            onClick={formProp.submitForm}
            disabled={formProp.isSubmitting || !formProp.dirty}
          >
            {formProp.isSubmitting ? submittingText[submitText] : submitText}
          </Button>
        </Box>
      </Flex>
    </FlexFooter>
  );
};

const PreviewModalWrapper = ({
  values,
  close,
  submitForm,
  incidentType,
  activeAccount,
  currentAccountMeta,
  components,
  componentGroups
}: {
  values: any,
  close: any,
  incidentType: any,
  submitForm: any,
  activeAccount: any,
  currentAccountMeta: any,
  components: any,
  componentGroups: any
}) => (
  <>
    <PreviewModal
      incidentType={incidentType}
      activeAccount={activeAccount}
      currentAccountMeta={currentAccountMeta}
      values={values}
      components={components}
      componentGroups={componentGroups}
    />
    <ModalFooter>
      <Flex justifyContent="space-between" width="100%">
        <PreviewHelpText alignItems="center">
          {i18n.t('components.createIncident.pressEscClose')}
        </PreviewHelpText>
        <Flex>
          <Button inline type="secondary" onClick={close}>
            {i18n.t('components.createIncident.close')}
          </Button>
        </Flex>
      </Flex>
    </ModalFooter>
  </>
);

const PreviewHelpText = styled(Flex)`
  opacity: 0.4;
  padding-left: 10px;
  font-size: 13px;
`;

const FlexFooter = styled(Flex)`
  margin-top: 16px;
  border-top: solid 1px #e4e2e2;
  background: #fff;
  position: sticky;
  bottom: 0;
  padding: 16px 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #cfd7df;
  z-index: 2;
`;

FlexFooter.defaultProps = {
  py: 3,
  px: '20px'
};

export default FormFooter;
